import {Pipe, PipeTransform} from '@angular/core';
import {AuthService} from "../_services/auth.service";

@Pipe({
    name: 'permissionsDisplay',

})
export class PermissionsDisplayPipe implements PipeTransform {

    constructor(private authService: AuthService) {
    }

    async transform(value: string): Promise<string> {
        return await this.authService.getDynamicSettings().then((r): string => {
            if (r.is_raa) {
                switch (value) {
                    case 'View, Comment and Add':
                        return 'View and Add'
                    case 'Add but not View or Comment':
                        return 'Add Only'
                    default :
                        return value
                }
            } else {
                return value;
            }
        }).catch((err: Error): string => {
            return value;
        });
    }
}
